export const widgetConstants ={
    GETTING_WIDGETJSON_REQUEST:"GETTING_WIDGETJSON_REQUEST",
    GETTING_WIDGETJSON_SUCCESS:"GETTING_WIDGETJSON_SUCCESS",
    GETTING_WIDGETJSON_ERROR:"GETTING_WIDGETJSON_ERROR"

}